/** @jsx jsx */
import React, { Component } from "react";
import { jsx, Box } from "theme-ui";
import StatusBox from "./statusBox";
import Popup from "./popup";

/*
* contribType: string;
* showPopup: ();
* data: any;
*/
class ContribStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPopup: false,
        };
    }

    togglePopUp = () => {
        const { showPopup } = this.state;
        this.setState({ showPopup: !showPopup });
    };

    render() {
        const { contribType, data } = this.props;
        const { showPopup } = this.state;
        let value = 0;
        let maxValue = 0;
        const dataVar = data.maturity_checklist;

        switch (contribType) {
            case "Experimental":
                maxValue = dataVar.experimental.length;
                dataVar.experimental.map((val) => {
                    if (val.passed === true) {
                        value += 1;
                    }
                    return null;
                });
                break;

            case "Beta":
                maxValue = dataVar.beta.length;
                dataVar.beta.map((val) => {
                    if (val.passed === true) {
                        value += 1;
                    }
                    return null;
                });
                break;

            case "Production":
                maxValue = dataVar.production.length;
                dataVar.production.map((val) => {
                    if (val.passed === true) {
                        value += 1;
                    }
                    return null;
                });
                break;

            default:
                break;
        }

        const ratio = Math.round(value / maxValue);
        let className;
        if (value === 0) {
            className = "none";
        } else if (value > 0 && ratio < 0.5) {
            className = "red";
        } else if (value === maxValue) {
            className = "green";
        } else {
            className = "orange";
        }

        return (
            <>
                <Box sx={{ cursor: "pointer" }} onClick={() => this.togglePopUp()}>
                    <StatusBox className={className} blockName={contribType} value={value} maxValue={maxValue} />
                </Box>
                {showPopup &&
                    <Popup
                        popupData={data}
                        maxValue={maxValue}
                        value={value}
                        contribType={contribType}
                        toggle={this.togglePopUp}
                    />
                }
            </>
        );
    }
}

export default ContribStatus;
